"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IP_BLACKLIST_TYPE_LABEL = void 0;
exports.formatBlockDuration = formatBlockDuration;
exports.formatBlockUntil = formatBlockUntil;
exports.ipBlacklistDetailApi = ipBlacklistDetailApi;
exports.ipBlacklistListApi = ipBlacklistListApi;
exports.ipBlacklistUnblockApi = ipBlacklistUnblockApi;
exports.parseIpBlacklistDetail = parseIpBlacklistDetail;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ipBlacklistListApi(params) {
  return (0, _request.default)({
    url: '/admin/ipblacklist/list',
    method: 'get',
    params: params
  });
}
function ipBlacklistDetailApi(id) {
  return (0, _request.default)({
    url: '/admin/ipblacklist/detail',
    method: 'get',
    params: {
      id: id
    }
  });
}
function ipBlacklistUnblockApi(id) {
  return (0, _request.default)({
    url: '/admin/ipblacklist/unblock',
    method: 'get',
    params: {
      id: id
    }
  });
}
var IP_BLACKLIST_TYPE_LABEL = exports.IP_BLACKLIST_TYPE_LABEL = {
  IP_LOGIN: '同一IP登录失败',
  ACCOUNT_LOGIN: '同一账号登录失败',
  VERIFY_CODE: '验证码请求超限'
};
function parseIpBlacklistDetail(detail) {
  if (!detail) {
    return {
      blockTypeLabel: '',
      summary: '',
      items: []
    };
  }
  try {
    var parsed = typeof detail === 'string' ? JSON.parse(detail) : detail;
    return {
      blockTypeLabel: parsed.blockTypeLabel || IP_BLACKLIST_TYPE_LABEL[parsed.blockType] || '',
      summary: parsed.summary || '',
      items: Array.isArray(parsed.items) ? parsed.items : []
    };
  } catch (e) {
    return {
      blockTypeLabel: '',
      summary: '',
      items: []
    };
  }
}
function formatBlockDuration(seconds) {
  var value = Number(seconds);
  if (!value || value <= 0) {
    return '永久（需手动解封）';
  }
  if (value % 86400 === 0) {
    return "".concat(value / 86400, "\u5929");
  }
  if (value % 3600 === 0) {
    return "".concat(value / 3600, "\u5C0F\u65F6");
  }
  if (value % 60 === 0) {
    return "".concat(value / 60, "\u5206\u949F");
  }
  return "".concat(value, "\u79D2");
}
function formatBlockUntil(until, status) {
  if (Number(status) !== 1 || !until) {
    return '-';
  }
  return until;
}